<script>
    import { LMDContainer, LButton } from "@ztl-uwu/labui";
	import { push } from 'svelte-spa-router';
    import md from "./syntax_highlight.md";
</script>

<h1>Colors</h1>
<p>Lab Design uses vibrant and high saturation colors.</p>
<p>LabUI provides the following colors. Follow them closely to get a consistent look.</p>

<div class="color-card-outer" style="margin-bottom: 50px;">
    <h1>Primary Colors</h1>
    <div class="color-card-holder">
        <div style="width: 40px;">
            <div class="color-primary"><span class="color-id"></span></div>
            <div class="color-secondary"><span class="color-id">⑨</span></div>
            <div class="color-secondary"><span class="color-id">⑧</span></div>
            <div class="color-secondary"><span class="color-id">⑦</span></div>
            <div class="color-secondary"><span class="color-id">⑥</span></div>
            <div class="color-secondary"><span class="color-id">⑤</span></div>
            <div class="color-secondary"><span class="color-id">④</span></div>
            <div class="color-secondary"><span class="color-id">③</span></div>
            <div class="color-secondary"><span class="color-id">②</span></div>
            <div class="color-secondary"><span class="color-id">①</span></div>
        </div>
        <div class="color-card first">
            <div class="color-primary green"><span class="color-id">⑥</span><span class="color-name">#23A536</span></div>
            <div class="color-secondary green9"><span class="color-name">#1E5020</span></div>
            <div class="color-secondary green8"><span class="color-name">#226B27</span></div>
            <div class="color-secondary green7"><span class="color-name">#24882F</span></div>
            <div class="color-secondary green6"><span class="color-name">#23A536</span></div>
            <div class="color-secondary green5"><span class="color-name">#57B558</span></div>
            <div class="color-secondary green4"><span class="color-name">#7CC479</span></div>
            <div class="color-secondary black-font green3"><span class="color-name">#9ED399</span></div>
            <div class="color-secondary black-font green2"><span class="color-name">#BFE2BB</span></div>
            <div class="color-secondary black-font green1 last"><span class="color-name">#DFF1DC</span></div>
            <p align="center" class="comment">Green</p>
        </div>
        <div class="color-card middle">
            <div class="color-primary yellow"><span class="color-id">⑤</span><span class="color-name">#F9B705</span></div>
            <div class="color-secondary yellow9"><span class="color-name">#4F3B14</span></div>
            <div class="color-secondary yellow8"><span class="color-name">#765716</span></div>
            <div class="color-secondary yellow7"><span class="color-name">#A07616</span></div>
            <div class="color-secondary yellow6"><span class="color-name">#CB9612</span></div>
            <div class="color-secondary yellow5"><span class="color-name">#F9B705</span></div>
            <div class="color-secondary yellow4"><span class="color-name">#FFC247</span></div>
            <div class="color-secondary black-font yellow3"><span class="color-name">#FFCE6F</span></div>
            <div class="color-secondary black-font yellow2"><span class="color-name">#FFDA93</span></div>
            <div class="color-secondary black-font yellow1 last"><span class="color-name">#FFE6B7</span></div>
            <p align="center" class="comment">Yellow</p>
        </div>
        <div class="color-card middle">
            <div class="color-primary blue"><span class="color-id">⑥</span><span class="color-name">#5BB2EC</span></div>
            <div class="color-secondary blue9"><span class="color-name">#33556F</span></div>
            <div class="color-secondary blue8"><span class="color-name">#407397</span></div>
            <div class="color-secondary blue7"><span class="color-name">#4E92C0</span></div>
            <div class="color-secondary blue6"><span class="color-name">#5BB2EC</span></div>
            <div class="color-secondary blue5"><span class="color-name">#7EBEEF</span></div>
            <div class="color-secondary blue4"><span class="color-name">#9BCBF3</span></div>
            <div class="color-secondary black-font blue3"><span class="color-name">#B6D8F6</span></div>
            <div class="color-secondary black-font blue2"><span class="color-name">#CFE5F9</span></div>
            <div class="color-secondary black-font blue1 last"><span class="color-name">#E7F2FC</span></div>
            <p align="center" class="comment">Blue</p>
        </div>
        <div class="color-card middle">
            <div class="color-primary red"><span class="color-id">⑥</span><span class="color-name">#F06A5E</span></div>
            <div class="color-secondary red9"><span class="color-name">#723730</span></div>
            <div class="color-secondary red8"><span class="color-name">#9A473F</span></div>
            <div class="color-secondary red7"><span class="color-name">#C4584E</span></div>
            <div class="color-secondary red6"><span class="color-name">#F06A5E</span></div>
            <div class="color-secondary red5"><span class="color-name">#F78477</span></div>
            <div class="color-secondary red4"><span class="color-name">#FC9E91</span></div>
            <div class="color-secondary black-font red3"><span class="color-name">#FFB6AB</span></div>
            <div class="color-secondary black-font red2"><span class="color-name">#FFCEC7</span></div>
            <div class="color-secondary black-font red1 last"><span class="color-name">#FFE7E2</span></div>
            <p align="center" class="comment">Red</p>
        </div>
    </div>
</div>

<div class="color-card-outer" style="margin-bottom: 50px;">
    <h1>Grey</h1>
    <div class="color-card-holder">
        <div class="color-card-3 first">
            <div class="color-primary grey"><span class="color-id">⑥</span><span class="color-name">#707070</span></div>
            <div class="color-secondary grey9"><span class="color-id rp">⑨</span><span class="color-name">#272727</span></div>
            <div class="color-secondary grey8"><span class="color-id rp">⑧</span><span class="color-name">#383838</span></div>
            <div class="color-secondary grey7"><span class="color-id rp">⑦</span><span class="color-name">#4A4A4A</span></div>
            <div class="color-secondary grey6"><span class="color-id rp">⑥</span><span class="color-name">#5D5D5D</span></div>
            <div class="color-secondary grey5"><span class="color-id rp">⑤</span><span class="color-name">#707070</span></div>
            <div class="color-secondary grey4"><span class="color-id rp">④</span><span class="color-name">#868686</span></div>
            <div class="color-secondary grey3"><span class="color-id rp">③</span><span class="color-name">#9D9D9D</span></div>
            <div class="color-secondary grey2"><span class="color-id rp">②</span><span class="color-name">#B5B5B5</span></div>
            <div class="color-secondary black-font grey1 last"><span class="color-id rp black-font">①</span><span class="color-name">#CDCDCD</span></div>
            <p align="center" class="comment">Grey</p>
        </div>
        <div class="color-card-3 middle">
            <div class="color-primary cgrey"><span class="color-id">④</span><span class="color-name">#68696C</span></div>
            <div class="color-secondary-6 cgrey6"><span class="color-id rp">⑥</span><span class="color-name">#252526</span></div>
            <div class="color-secondary-6 cgrey5"><span class="color-id rp">⑤</span><span class="color-name">#454648</span></div>
            <div class="color-secondary-6 cgrey4"><span class="color-id rp">④</span><span class="color-name">#68696C</span></div>
            <div class="color-secondary-6 cgrey3"><span class="color-id rp">③</span><span class="color-name">#8D8F93</span></div>
            <div class="color-secondary-6 cgrey2"><span class="color-id rp">②</span><span class="color-name">#B4B7BC</span></div>
            <div class="color-secondary-6 black-font cgrey1 last"><span class="color-id rp black-font">①</span><span class="color-name">#DCE0E6</span></div>
            <p align="center" class="comment">Cold Grey</p>
        </div>
        <div class="color-card-3 middle">
            <div class="color-primary white black-font"><span class="color-id black-font">①</span><span class="color-name">#FFFFFF</span></div>
            <div class="color-secondary-5 black-font transparent"><span class="color-name">transparent</span></div>
            <div class="color-secondary-5 black-font white3"><span class="color-id black-font rp">③</span><span class="color-name">#EFF1F5</span></div>
            <div class="color-secondary-5 black-font white2"><span class="color-id black-font rp">②</span><span class="color-name">#FAFAFE</span></div>
            <div class="color-secondary-5 black-font white1"><span class="color-id black-font rp">①</span><span class="color-name">#FFFFFF</span></div>
            <div class="color-secondary-5 last black"><span class="color-name">#000000</span></div>
            <p align="center" class="comment">White & Black</p>
        </div>
    </div>
</div>

<div class="color-card-outer" style="margin-bottom: 50px;">
    <h1>Border</h1>
    <div class="color-card-holder">
        <div class="color-card-3 first">
            <div class="color-primary border1 white singal"><span class="color-id black-font">Cold Grey ①</span><span class="color-name black-font">#DCE0E6</span></div>
            <p align="center" class="comment">Border ①</p>
        </div>
        <div class="color-card-3 middle">
            <div class="color-primary border2 white singal"><span class="color-id black-font">Cold Grey ②</span><span class="color-name black-font">#B4B7BC</span></div>
            <p align="center" class="comment">Border ②</p>
        </div>
        <div class="color-card-3 middle">
            <div class="color-primary border3 white singal"><span class="color-id black-font">Cold Grey ③</span><span class="color-name black-font">#8D8F93</span></div>
            <p align="center" class="comment">Border ③</p>
        </div>
    </div>
</div>

<LMDContainer content={ md }></LMDContainer>

<LButton color="yellow" on:click={() => push('/guide/typography')}>Typography</LButton>

<style lang="scss">
    @import '../../styles/main.scss';

    .comment {
        margin-top: 10px;
        margin-bottom: 8px;
        user-select: none;
        color: $grey;
    }

    .color-card-outer {
        padding: 25px 60px 40px 60px;
        background-color: $white3;
        border-radius: $border-radius-large;
    }

    .color-card-holder {
        margin-top: 30px;
        display: flex;
    }

    .color-card {
        width: calc(25% - 15px);
    }

    .color-card-3 {
        width: calc(33.33% - 15px);
    }

    .color-primary {
        border-radius: 8px 8px 0 0;
        position: relative;
        height: 120px;
    }

    .color-secondary {
        position: relative;
        height: 32px;
    }

    .color-secondary-6 {
        position: relative;
        height: 48px;
    }

    .color-secondary-5 {
        position: relative;
        height: 57.6px;
    }

    .singal {
        border-radius: 8px;
    }

    .last {
        border-radius: 0 0 8px 8px;
    }

    .color-name {
        font-family: 'Fira Code', consolas, monospace;
    }

    .color-id {
        user-select: none;
    }

    .color-primary > .color-id {
        position: absolute;
        top: 12px;
        left: 15px;
        font-size: 16px;
        font-weight: 600;
        color: $white3;
    }

    .color-secondary > .color-id.rp,
    .color-secondary-5 > .color-id.rp,
    .color-secondary-6 > .color-id.rp {
        position: absolute;
        bottom: 8px;
        left: 15px;
        color:  $white3;
        font-size: 14px;
        font-weight: 500;
    }

    .color-secondary > .color-id,
    .color-secondary-5 > .color-id,
    .color-secondary-6 > .color-id {
        position: absolute;
        bottom: 8px;
        color:  $c_grey3;
        font-size: 14px;
        font-weight: 500;
    }

    .color-primary > .color-name {
        position: absolute;
        right: 15px;
        bottom: 12px;
        color: #fff;
        font-size: 17px;
        font-weight: 600;
    }

    .color-secondary > .color-name,
    .color-secondary-5 > .color-name,
    .color-secondary-6 > .color-name {
        position: absolute;
        right: 15px;
        bottom: 8px;
        color: #fff;
        font-size: 12px;
        font-weight: 500;
    }

    .black-font,
    .black-font > .color-name {
        color: #707070 !important;
    }

    .first {
        margin-left: 0;
    }

    .middle {
        margin-left: 20px;
    }

    .green { background-color: $green; }
    .green1 { background-color: $green1; }
    .green2 { background-color: $green2; }
    .green3 { background-color: $green3; }
    .green4 { background-color: $green4; }
    .green5 { background-color: $green5; }
    .green6 { background-color: $green6; }
    .green7 { background-color: $green7; }
    .green8 { background-color: $green8; }
    .green9 { background-color: $green9; }

    .yellow { background-color: $yellow; }
    .yellow1 { background-color: $yellow1; }
    .yellow2 { background-color: $yellow2; }
    .yellow3 { background-color: $yellow3; }
    .yellow4 { background-color: $yellow4; }
    .yellow5 { background-color: $yellow5; }
    .yellow6 { background-color: $yellow6; }
    .yellow7 { background-color: $yellow7; }
    .yellow8 { background-color: $yellow8; }
    .yellow9 { background-color: $yellow9; }

    .blue { background-color: $blue; }
    .blue1 { background-color: $blue1; }
    .blue2 { background-color: $blue2; }
    .blue3 { background-color: $blue3; }
    .blue4 { background-color: $blue4; }
    .blue5 { background-color: $blue5; }
    .blue6 { background-color: $blue6; }
    .blue7 { background-color: $blue7; }
    .blue8 { background-color: $blue8; }
    .blue9 { background-color: $blue9; }

    .red { background-color: $red; }
    .red1 { background-color: $red1; }
    .red2 { background-color: $red2; }
    .red3 { background-color: $red3; }
    .red4 { background-color: $red4; }
    .red5 { background-color: $red5; }
    .red6 { background-color: $red6; }
    .red7 { background-color: $red7; }
    .red8 { background-color: $red8; }
    .red9 { background-color: $red9; }

    .grey { background-color: $grey; }
    .grey1 { background-color: $grey1; }
    .grey2 { background-color: $grey2; }
    .grey3 { background-color: $grey3; }
    .grey4 { background-color: $grey4; }
    .grey5 { background-color: $grey5; }
    .grey6 { background-color: $grey6; }
    .grey7 { background-color: $grey7; }
    .grey8 { background-color: $grey8; }
    .grey9 { background-color: $grey9; }

    .cgrey { background-color: $c_grey; }
    .cgrey1 { background-color: $c_grey1; }
    .cgrey2 { background-color: $c_grey2; }
    .cgrey3 { background-color: $c_grey3; }
    .cgrey4 { background-color: $c_grey4; }
    .cgrey5 { background-color: $c_grey5; }
    .cgrey6 { background-color: $c_grey6; }

    .white { background-color: #FFFFFF; @include border-normal($border1); height: 116px; border-bottom: none;  }
    .white1 { background-color: $white1; }
    .white2 { background-color: $white2; }
    .white3 { background-color: $white3; }
    .transparent {
        background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 100 100'><path d='M0 98 L100 0 L100 1 L1 98' fill='%23f78477' /></svg>");
        @include border-small($red2);
        height: 55px;
    }
    .black { background-color: $black; }

    .border1 { @include border-large($border1); }
    .border2 { @include border-large($border2); }
    .border3 { @include border-large($border3); }
</style>
